<div class="leitor-side-menu-container">
  <div class="leitor-side-menu">
    <label class="leitor-side-menu-label">Comentário</label>
    <div
      [ngClass]="{ 'leitor-side-menu-textarea-container-ativo': textareAtivo }"
      class="leitor-side-menu-textarea-container"
    >
      <textarea
        class="leitor-side-menu-textarea"
        placeholder="Escreva aqui seu comentário..."
        matInput
        [(ngModel)]="textoSidemobile"
        (ngModelChange)="setText()"
        (focus)="textareChange($event)"
        (blur)="textareChange($event)"
      ></textarea>
    </div>
    <label class="leitor-side-menu-label">Cor da marcação</label>

    <div class="leitor-side-menu-button-scrolling">
      <div *ngFor="let opcao of opcoesExibir" class="leitor-side-menu-button">
        <app-button-leitor-side-menu
          [opcao]="opcao"
          (toggleButtonLeitor)="toggle($event)"
          [ativo]="
            opcaoSelecionada?.modo === opcao.modo &&
            opcaoSelecionada?.tipo === opcao.tipo
          "
        ></app-button-leitor-side-menu>
      </div>
    </div>

    <app-button-wrapper
      (buttonTrue)="buttonTrue()"
      (buttonFalse)="buttonFalse()"
    ></app-button-wrapper>
  </div>
</div>
